var LogoBrand;

(function (LogoBrand) {
  LogoBrand["Caviar"] = "BRAND_CAVIAR";
  LogoBrand["DoorDash"] = "BRAND_DOORDASH";
})(LogoBrand || (LogoBrand = {}));

var LogoSize;

(function (LogoSize) {
  LogoSize["Small"] = "LOGO_SIZES/SMALL";
  LogoSize["Base"] = "LOGO_SIZES/BASE";
  LogoSize["Large"] = "LOGO_SIZES/LARGE";
  LogoSize["Huge"] = "LOGO_SIZES/HUGE";
})(LogoSize || (LogoSize = {}));

var LogoType;

(function (LogoType) {
  LogoType["Logo"] = "LOGO";
  LogoType["LogoMark"] = "LOGO_MARK";
})(LogoType || (LogoType = {}));

export { LogoBrand, LogoSize, LogoType };
